export default class Usuario {

    constructor(rela_nome, rela_sobrenome, rela_dtReg, rela_dtLastLogin, rela_qntLogins, rela_email, rela_telefone, rela_faturaRazao, rela_arrayLogins, _id) {
        this.rela_nome = rela_nome;
        this.rela_sobrenome = rela_sobrenome;
        this.rela_dtReg = new Date(rela_dtReg);
        this.rela_dtLastLogin = rela_dtLastLogin ? new Date(rela_dtLastLogin) : undefined;
        this.rela_qntLogins = rela_qntLogins;
        this.rela_email = rela_email;
        this.rela_telefone = rela_telefone != undefined && rela_telefone.length == 8 ? rela_telefone.replace(/^(\d{4})(\d)/, "$1-$2")
            : rela_telefone != undefined && rela_telefone.length == 11 ? rela_telefone.replace(/^(\d{2})(\d{5})(\d)/, "($1) $2-$3")
                : rela_telefone
        this.rela_faturaRazao = rela_faturaRazao;
        this.rela_arrayLogins = rela_arrayLogins;
        this._id = _id;
    }

}





// WEBPACK FOOTER //
// ./src/domain/conta/usuario/RelatorioUsuario.js